<template>
  <div>
    <div class="instrument-name" @click="showDialog = true">
      <InstrumentNameCell v-bind="$props"/>
    </div>

    <!--TODO get rid of this dialog in the cell component-->
    <fin-dialog v-model="showDialog" fullscreen dense>
          <!-- this component is only used in the onboarding.
          no-escape-link is set so that the user cannot quit the onboarding -->
          <fin-company-page v-if="value.assetClass === 'SHARE'"
                            :id="value.id"
                            v-bind="$props"
                            no-escape-link/>
          <fin-etf-page v-else
                        :id="value.id"
                        v-bind="$props"
                        no-escape-link/>

    </fin-dialog>

  </div>
</template>

<script>
import FinCompanyPage from "@/components/pages/finCompanyPage"
import InstrumentNameCell from "./InstrumentNameCell"
import FinEtfPage from "@/components/pages/finEtfPage"

export default {
  name: "InstrumentNameCellToDetailDialog",
  props: {
    value: {},
    item: {},
    header: {},
    isMobile: {}
  },
  data() {
    return {
      showDialog: false
    }
  },
  components: {
    FinEtfPage,
    InstrumentNameCell,
    FinCompanyPage,
  }
}
</script>

<style scoped>
.instrument-name:hover {
  cursor: pointer;
}
</style>
